import React from 'react'

export function ShadowNinja({ className = '', pose = 'idle' }) {
  return (
    <svg
      viewBox="0 0 200 300"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="sn-suitGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1e1b4b" />
          <stop offset="100%" stopColor="#000000" />
        </linearGradient>
        <linearGradient id="sn-wrapGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4c1d95" />
          <stop offset="100%" stopColor="#2e1065" />
        </linearGradient>
        <filter id="sn-shadowGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="sn-eyeGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="sn-smokeGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="15" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <style>
        {`
          @keyframes sn-crouch {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(4px); }
          }
          @keyframes sn-floatWisp {
            0% { transform: translateY(0) scale(1); opacity: 0.8; }
            100% { transform: translateY(-40px) scale(0); opacity: 0; }
          }
          @keyframes sn-scarfWave {
            0%, 100% { transform: rotate(0deg); }
            50% { transform: rotate(-10deg); }
          }
          @keyframes sn-lunge {
            0%, 100% { transform: translateX(0); }
            50% { transform: translateX(15px); }
          }
          @keyframes sn-tuck {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
          }
          @keyframes sn-stumble {
            0%, 100% { transform: translateX(0) rotate(5deg); }
            50% { transform: translateX(5px) rotate(8deg); }
          }
          @keyframes sn-smoke {
            0% { transform: scale(0.9); opacity: 0.7; }
            50% { transform: scale(1.1); opacity: 0.9; }
            100% { transform: scale(0.9); opacity: 0.7; }
          }
          
          .sn-idle-anim { animation: sn-crouch 2.5s ease-in-out infinite; }
          .sn-wisp { animation: sn-floatWisp 2s ease-in infinite; transform-origin: center; }
          .sn-scarf-anim { animation: sn-scarfWave 3s ease-in-out infinite; transform-origin: top right; }
          .sn-attack-anim { animation: sn-lunge 0.4s ease-in-out infinite; }
          .sn-jump-anim { animation: sn-tuck 1.5s ease-in-out infinite; }
          .sn-hurt-anim { animation: sn-stumble 0.5s ease-in-out infinite; transform-origin: bottom center; }
          .sn-smoke-anim { animation: sn-smoke 3s ease-in-out infinite; transform-origin: center; }
        `}
      </style>

      {pose === 'idle' && (
        <g className="sn-idle-anim">
          <g fill="#8b5cf6" filter="url(#sn-shadowGlow)">
            <circle
              cx="60"
              cy="240"
              r="8"
              className="sn-wisp"
              style={{ animationDelay: '0s' }}
            />
            <circle
              cx="140"
              cy="200"
              r="6"
              className="sn-wisp"
              style={{ animationDelay: '0.5s' }}
            />
            <circle
              cx="80"
              cy="120"
              r="10"
              className="sn-wisp"
              style={{ animationDelay: '1s' }}
            />
            <circle
              cx="150"
              cy="150"
              r="7"
              className="sn-wisp"
              style={{ animationDelay: '1.5s' }}
            />
          </g>
          <g transform="translate(110, 70)" className="sn-scarf-anim">
            <path
              d="M0 0 Q 40 20 60 60 Q 30 40 -10 20 Z"
              fill="url(#sn-wrapGrad)"
            />
            <path d="M-5 10 Q 50 40 70 90 Q 40 60 -15 30 Z" fill="#3b0764" />
          </g>
          <path
            d="M110 170 L140 230 L160 230 L130 160 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M135 210 L155 210 L165 240 L135 240 Z"
            fill="url(#sn-wrapGrad)"
          />
          <path
            d="M120 100 L160 130 L150 145 L110 115 Z"
            fill="url(#sn-suitGrad)"
          />
          <path d="M150 135 L190 120 L195 125 L155 145 Z" fill="#94a3b8" />
          <circle cx="155" cy="140" r="8" fill="url(#sn-wrapGrad)" />
          <path
            d="M70 80 L120 80 L130 160 L80 170 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M75 100 L125 95 L127 110 L77 115 Z"
            fill="url(#sn-wrapGrad)"
          />
          <path
            d="M78 125 L128 120 L130 135 L80 140 Z"
            fill="url(#sn-wrapGrad)"
          />
          <path
            d="M80 160 L50 220 L70 230 L100 165 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M55 200 L80 205 L70 240 L40 230 Z"
            fill="url(#sn-wrapGrad)"
          />
          <path d="M80 90 L40 130 L55 145 L95 105 Z" fill="url(#sn-suitGrad)" />
          <path d="M45 135 L10 160 L5 150 L40 125 Z" fill="#94a3b8" />
          <circle cx="45" cy="135" r="10" fill="url(#sn-wrapGrad)" />
          <g transform="translate(95, 60)">
            <circle cx="0" cy="0" r="25" fill="url(#sn-suitGrad)" />
            <path
              d="M-20 -5 Q 0 5 20 -5 L 15 10 Q 0 15 -15 10 Z"
              fill="#000000"
            />
            <circle
              cx="-8"
              cy="2"
              r="3"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
            />
            <circle
              cx="8"
              cy="2"
              r="3"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
            />
          </g>
        </g>
      )}

      {pose === 'attack' && (
        <g className="sn-attack-anim">
          {/* Shadow Slash Trails */}
          <path
            d="M40 120 Q 120 80 200 140 Q 120 100 40 130 Z"
            fill="#a855f7"
            filter="url(#sn-shadowGlow)"
            opacity="0.6"
          />
          <path
            d="M40 140 Q 120 180 200 120 Q 120 160 40 130 Z"
            fill="#a855f7"
            filter="url(#sn-shadowGlow)"
            opacity="0.6"
          />

          {/* Scarf trailing straight back */}
          <g transform="translate(80, 70)">
            <path
              d="M0 0 Q -40 10 -80 0 Q -40 20 0 10 Z"
              fill="url(#sn-wrapGrad)"
            />
            <path d="M-5 5 Q -50 20 -90 10 Q -50 30 0 15 Z" fill="#3b0764" />
          </g>

          {/* Back Leg extended */}
          <path
            d="M90 160 L30 220 L50 230 L100 170 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M35 210 L55 215 L45 240 L25 235 Z"
            fill="url(#sn-wrapGrad)"
          />

          {/* Front Leg lunging */}
          <path
            d="M110 160 L160 220 L140 230 L100 170 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M145 210 L125 215 L135 240 L155 235 Z"
            fill="url(#sn-wrapGrad)"
          />

          {/* Torso horizontal */}
          <path
            d="M80 80 L130 90 L110 170 L70 160 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M85 100 L125 105 L120 120 L80 115 Z"
            fill="url(#sn-wrapGrad)"
          />

          {/* Back Arm & Dagger (Upward slash) */}
          <path
            d="M120 100 L160 80 L170 95 L130 115 Z"
            fill="url(#sn-suitGrad)"
          />
          <path d="M165 85 L200 60 L205 70 L170 95 Z" fill="#94a3b8" />
          <circle cx="165" cy="90" r="8" fill="url(#sn-wrapGrad)" />

          {/* Front Arm & Dagger (Downward slash) */}
          <path
            d="M110 110 L150 140 L140 155 L100 125 Z"
            fill="url(#sn-suitGrad)"
          />
          <path d="M145 145 L180 170 L175 180 L140 155 Z" fill="#94a3b8" />
          <circle cx="145" cy="150" r="8" fill="url(#sn-wrapGrad)" />

          {/* Head forward */}
          <g transform="translate(140, 70) rotate(20)">
            <circle cx="0" cy="0" r="25" fill="url(#sn-suitGrad)" />
            <path
              d="M-20 -5 Q 0 5 20 -5 L 15 10 Q 0 15 -15 10 Z"
              fill="#000000"
            />
            <circle
              cx="-2"
              cy="2"
              r="3"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
            />
            <circle
              cx="12"
              cy="2"
              r="3"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
            />
          </g>
        </g>
      )}

      {pose === 'jump' && (
        <g className="sn-jump-anim">
          {/* Scarf trailing up */}
          <g transform="translate(100, 100)">
            <path
              d="M0 0 Q 20 -40 10 -80 Q 30 -40 10 0 Z"
              fill="url(#sn-wrapGrad)"
            />
            <path d="M5 -5 Q 30 -50 20 -90 Q 40 -50 15 -5 Z" fill="#3b0764" />
          </g>

          {/* Tucked Body */}
          <path
            d="M80 120 L120 120 L110 180 L90 180 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M85 130 L115 130 L112 145 L88 145 Z"
            fill="url(#sn-wrapGrad)"
          />

          {/* Tucked Legs */}
          <path
            d="M90 180 L70 150 L85 140 L100 170 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M110 180 L130 150 L115 140 L100 170 Z"
            fill="url(#sn-suitGrad)"
          />

          {/* Arms crossed holding daggers */}
          <path
            d="M80 130 L60 160 L75 170 L95 140 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M120 130 L140 160 L125 170 L105 140 Z"
            fill="url(#sn-suitGrad)"
          />

          <path d="M65 165 L40 190 L45 195 L70 170 Z" fill="#94a3b8" />
          <path d="M135 165 L160 190 L155 195 L130 170 Z" fill="#94a3b8" />

          {/* Head tucked */}
          <g transform="translate(100, 100) rotate(180)">
            <circle cx="0" cy="0" r="25" fill="url(#sn-suitGrad)" />
            <path
              d="M-20 -5 Q 0 5 20 -5 L 15 10 Q 0 15 -15 10 Z"
              fill="#000000"
            />
            <circle
              cx="-8"
              cy="2"
              r="3"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
            />
            <circle
              cx="8"
              cy="2"
              r="3"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
            />
          </g>

          {/* Trailing wisps */}
          <g fill="#8b5cf6" filter="url(#sn-shadowGlow)">
            <circle cx="100" cy="200" r="8" className="sn-wisp" />
            <circle
              cx="80"
              cy="220"
              r="6"
              className="sn-wisp"
              style={{ animationDelay: '0.2s' }}
            />
            <circle
              cx="120"
              cy="210"
              r="7"
              className="sn-wisp"
              style={{ animationDelay: '0.4s' }}
            />
          </g>
        </g>
      )}

      {pose === 'hurt' && (
        <g className="sn-hurt-anim">
          {/* Scattered Wisps */}
          <g fill="#8b5cf6" filter="url(#sn-shadowGlow)">
            <circle cx="40" cy="100" r="10" />
            <circle cx="160" cy="80" r="8" />
            <circle cx="180" cy="180" r="12" />
            <circle cx="20" cy="200" r="6" />
          </g>

          {/* Scarf flying forward */}
          <g transform="translate(100, 70)">
            <path
              d="M0 0 Q -40 20 -60 60 Q -30 40 10 20 Z"
              fill="url(#sn-wrapGrad)"
            />
          </g>

          {/* Stumbling Legs */}
          <path
            d="M100 170 L140 240 L160 230 L120 160 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M80 170 L60 250 L80 260 L100 180 Z"
            fill="url(#sn-suitGrad)"
          />

          {/* Torso leaning back */}
          <path
            d="M90 80 L140 90 L120 170 L70 160 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M95 100 L135 105 L130 120 L90 115 Z"
            fill="url(#sn-wrapGrad)"
          />

          {/* Arms thrown out */}
          <path
            d="M90 90 L40 100 L50 120 L100 110 Z"
            fill="url(#sn-suitGrad)"
          />
          <path
            d="M140 90 L180 120 L170 140 L130 110 Z"
            fill="url(#sn-suitGrad)"
          />

          {/* Dropped daggers */}
          <path d="M30 140 L10 180 L15 185 L35 145 Z" fill="#94a3b8" />
          <path d="M190 150 L210 190 L205 195 L185 155 Z" fill="#94a3b8" />

          {/* Head thrown back */}
          <g transform="translate(120, 60) rotate(30)">
            <circle cx="0" cy="0" r="25" fill="url(#sn-suitGrad)" />
            <path
              d="M-20 -5 Q 0 5 20 -5 L 15 10 Q 0 15 -15 10 Z"
              fill="#000000"
            />
            <circle
              cx="-8"
              cy="2"
              r="3"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
              opacity="0.5"
            />
            <circle
              cx="8"
              cy="2"
              r="3"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
              opacity="0.5"
            />
          </g>
        </g>
      )}

      {pose === 'block' && (
        <g>
          {/* Smoke Cloud */}
          <circle
            cx="100"
            cy="150"
            r="80"
            fill="#3b0764"
            filter="url(#sn-smokeGlow)"
            className="sn-smoke-anim"
          />
          <circle
            cx="120"
            cy="180"
            r="60"
            fill="#4c1d95"
            filter="url(#sn-smokeGlow)"
            className="sn-smoke-anim"
            style={{ animationDelay: '0.5s' }}
          />
          <circle
            cx="70"
            cy="160"
            r="70"
            fill="#2e1065"
            filter="url(#sn-smokeGlow)"
            className="sn-smoke-anim"
            style={{ animationDelay: '1s' }}
          />

          {/* Faint Silhouette in smoke */}
          <g opacity="0.3">
            <path d="M70 180 L130 180 L110 240 L90 240 Z" fill="#000" />
            <path d="M80 120 L120 120 L130 180 L70 180 Z" fill="#000" />
            <circle cx="100" cy="100" r="20" fill="#000" />
            {/* Glowing eyes piercing smoke */}
            <circle
              cx="92"
              cy="100"
              r="4"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
              opacity="1"
            />
            <circle
              cx="108"
              cy="100"
              r="4"
              fill="#a855f7"
              filter="url(#sn-eyeGlow)"
              opacity="1"
            />
          </g>
        </g>
      )}
    </svg>
  )
}
